import React from 'react';
import CrossfadeImages from 'components/Contentful/ContentfulDynamicHero/VerticalHero/RotatingBackgroundHero/CrossfadeImages';

import { BottomGradient, StyledCarouselBackground } from './styles';

const CarouselBackground = ({
  bottomGradient,
  desktopBackgroundStyles,
  mobileBackgroundStyles,
  mobileImages,
  desktopImages,
  variation,
}) => {
  const mobilePlaceholder = mobileImages?.[0]?.image?.file?.url;
  const desktopPlaceholder = desktopImages?.[0]?.image?.file?.url;

  return (
    <StyledCarouselBackground
      $desktopBackground={desktopBackgroundStyles || desktopPlaceholder}
      $mobileBackground={mobileBackgroundStyles || mobilePlaceholder}
      $width={variation === 'Constrained Width' ? 'constrained' : 'full'}
      className="carousel-background"
    >
      {mobileImages && <CrossfadeImages className="max-md" images={mobileImages} duration={4000} />}
      {desktopImages && (
        <CrossfadeImages className="min-md" images={desktopImages} duration={4000} />
      )}
      {bottomGradient && <BottomGradient styles={bottomGradient} className="bottom-gradient" />}
    </StyledCarouselBackground>
  );
};

export default CarouselBackground;
